import { cloneDeep } from 'lodash';
import { FooterContext } from '../SideBarFooter';
import React from 'react';
import { failureCardArray, recCardArray } from './mockData';
import { Classification } from '@wix/ambassador-devcenter-apps-v1-app/types';
export const initialState = {
    isFooterOpen: false,
    setIsFooterOpen: () => { },
    isPanelOpen: false,
    blockers: failureCardArray,
    recs: recCardArray,
    openPanel: () => { },
    closePanel: () => { },
    panelActiveTabId: 1,
    setPanelActiveTabId: () => { },
    navigationCallback: () => { },
    appId: '1234',
    isWixTpa: false,
    shouldCheckDismissCount: false,
    setShouldCheckDismissCount: () => { },
    dismissedCount: 0,
    canPublish: false,
    lastPublishedDate: '2022-08-04T07:55:39Z',
    t: () => { },
    userId: '',
    latestVersion: '',
    appClassification: Classification.SITE_APP,
};
export const compose = (...fns) => (initialData) => fns.reduce((data, fnToExecute) => fnToExecute(data), initialData);
export const renderFooterContext = (value = {}) => (children) => {
    const tmp = cloneDeep(value);
    return (React.createElement(FooterContext.Provider, { value: { ...initialState, ...tmp } }, children));
};
//# sourceMappingURL=testHelpers.js.map